import { toggleValues } from '@/lib/utils/storeUtils'
import { SYSTEM_LOADING_MUTATION_TOGGLE_LOADING } from '@/store/modules/system/loading/systemLoading.constant'

export default {
  [SYSTEM_LOADING_MUTATION_TOGGLE_LOADING] (state, value = undefined) {
    state.isLoading = toggleValues(state.isLoading, value)
  }
}
